<template>
  <div class="main">
    <Header
      :show="true"
      title="车辆预约"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div>
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="预约需要提取您的个人信息，请您放心我们将严格保护"
      />
      <van-form
        ref="order"
        @submit="submit"
      >
        <van-field
          v-model.trim="listQuery.plateNumber"
          name="车牌号"
          label="车牌号"
          placeholder="请输入"
          :maxlength="10"
          required
          :rules="[
            { required: true, message: '请输入货车的车牌号' },
            { validator: validPlateNumber, message: '请输入正确的车牌号' },
          ]"
        />
        <!--         
        <van-field
          v-model.trim="listQuery.name"
          name="姓名"
          label="姓名"
          placeholder="请输入您的姓名"
          :maxlength="20"
          :required="true"
          :rules="[
            { required: true, message: '请输入您的姓名' },
            {
              validator: validNickName,
              message: '请输入两字以上的姓名，仅支持中文',
            },
          ]"
        />
        <van-field
          v-model="listQuery.phone"
          name="手机号码"
          label="手机号码"
          placeholder="请输入手机号码"
          type="number"
          :maxlength="11"
          :rules="[
            { validator: validMobilePhone, message: '手机号格式不正确' },
          ]"
        /> -->
        <van-field
          v-model="listQuery.reason"
          rows="2"
          autosize
          label="访问事由"
          type="textarea"
          maxlength="100"
          placeholder="请输入访问事由"
          show-word-limit
        />
       
        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            :disabled="waiting"
            @click="handleConfirm"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { parseTime } from "@/utils";
import { showPhoneAlarm } from "@/global/function.js";
import {
  isPlateNumber,
  isPhone,
  isNickName,
  isSupplierName,
} from "@/utils/validate";
import Header from "@/views/components/header/index.vue";
import { Toast } from "vant";

import { createTruckOrderInfo, extCreateCarOrderInfo } from "@/api/order.js";
import { getList as getMaterialList } from "@/api/material.js";
import { getList as getSupplierList } from "@/api/supplier.js";
import { getOrderList as getTruckOrderList } from "@/api/order.js";

export default {
  name: "DashboardOrderCar",
  components: { Header },
  props: {},
  data() {
    const EDate = parseTime(new Date(), "{y}/{m}/{d}");
    const SDate = EDate;
    return {
      loading: false,
      waiting: false,
      listQuery: {
        name: "",
        phone: "",
        area: 1,
        carType: "其他车辆",
        truckType: "骨料货车",
        plateNumber: "",
        reason: "",
        material: "",
        materialType: 1,
        supplier: "",
        start: SDate,
        end: EDate,
        stay: 1,
        validEnable: 0,
      },
      start: {
        show: false,
      },
      end: {
        show: false,
      },
      material: {
        show: false,
        columns1: [],
        columns2: [],
      },
      truckType: {
        show: false,
        columns: ["骨料货车", "罐装货车"],
      },
      areaTemp: [1],
      areaList: [
        {
          id: 1,
          name: "办公区",
          value: false,
          disabled: true,
        },
        {
          id: 2,
          name: "原料区",
          value: false,
          disabled: false,
        },
      ],
      supplierList: null,
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handleClickLeft() {
      this.$router.push({ path: "/dashboard/reserve", query: {} });
    },
    disableToast() {
      Toast("未登录，不允许进行原料区预约");
    },
    handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      getMaterialList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            for (let i = 0; i < data.data.total; i++) {
              if (data.data.items[i].type === 1) {
                this.material.columns1.push(data.data.items[i].name);
              } else if (data.data.items[i].type === 2) {
                this.material.columns2.push(data.data.items[i].name);
              }
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleMaterialSelect(value) {
      this.listQuery.material = value;
      this.material.show = false;
    },
    handleTruckTypeSelect(value) {
      this.listQuery.truckType = value;
      if (this.listQuery.truckType === "骨料货车") {
        this.listQuery.materialType = 1;
      } else if (this.listQuery.truckType === "罐装货车") {
        this.listQuery.materialType = 2;
      } else {
        this.listQuery.materialType = 3;
      }
      this.truckType.show = false;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    handleConfirmStartDate(date) {
      this.listQuery.start = this.formatDate(date);

      const start = new Date(this.listQuery.start).getTime() / 1000;
      const end = new Date(this.listQuery.end).getTime() / 1000;
      this.listQuery.stay = (end - start) / (3600 * 24) + 1;

      this.start.show = false;
    },
    handleConfirmEndDate(date) {
      this.listQuery.end = this.formatDate(date);

      const start = new Date(this.listQuery.start).getTime() / 1000;
      const end = new Date(this.listQuery.end).getTime() / 1000;
      this.listQuery.stay = (end - start) / (3600 * 24) + 1;

      this.end.show = false;
    },
    validPlateNumber(value) {
      return new Promise((resolve) => {
        const result = isPlateNumber(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validNickName(value) {
      return new Promise((resolve) => {
        const result = isNickName(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    validSupplierName(value) {
      return new Promise((resolve) => {
        const result = isSupplierName(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          showPhoneAlarm(true, "toast", null, 2000, null, result, null);
          resolve(false);
        }
      });
    },
    validMobilePhone(value) {
      return new Promise((resolve) => {
        const result = isPhone(value);
        if (result === true) {
          resolve(true);
        } else {
          if (result === "手机号码不能为空") {
            resolve(true);
          } else {
            resolve(false);
          }
        }
      });
    },
    handleGetSupplierList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      getSupplierList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            this.supplierList = data.data.items;
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleGetTruckOrderList() {
      const data = {
        page: 1,
        limit: 1,
      };
      getTruckOrderList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.orderList = [];
            for (let i = 0; i < items.length; i++) {
              // this.listQuery.plateNumber = items[i].plateNumber
              this.listQuery.truckType = items[i].truckType;
              // this.listQuery.material = items[i].materialName
              this.listQuery.materialType = items[i].materialType;
              // this.listQuery.supplier = items[i].supplierName
              this.listQuery.name = items[i].name;
              this.listQuery.phone = items[i].phone;
              this.listQuery.reason = items[i].reason;
            }
            console.log("getOrderList");
            console.log(this.orderList);
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleConfirm() {
      this.$refs.order.submit();
    },
    submit() {
      const that = this;
      if (this.listQuery.area === 1) {
        const data = {
          plateNumber: this.listQuery.plateNumber,
          truckType: "其他车辆",
          materialName: "其他",
          materialType: 4,
          supplierName: this.listQuery.name,
          name: this.listQuery.name,
          phone: this.listQuery.phone,
          reason: this.listQuery.reason,
          startDate: new Date(this.listQuery.start).getTime(),
          endDate: new Date(this.listQuery.end).getTime(),
        };
        that.waiting = true;
        extCreateCarOrderInfo(data)
          .then((response) => {
            const { data } = response;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "预约",
                data.message
              )
            ) {
              that.$router.push({ path: "/dashboard/reserve", query: {} });
            }
          })
          .finally(() => {
            that.waiting = false;
          });
      } else {
        const data = {
          plateNumber: this.listQuery.plateNumber,
          truckType: this.listQuery.truckType,
          materialName: this.listQuery.material,
          materialType: this.listQuery.materialType,
          supplierName: this.listQuery.supplier,
          name: this.listQuery.name,
          phone: this.listQuery.phone,
          reason: this.listQuery.reason,
          startDate: new Date(this.listQuery.start).getTime(),
          endDate: new Date(this.listQuery.end).getTime(),
        };
        that.waiting = true;
        createTruckOrderInfo(data)
          .then((response) => {
            const { data } = response;
            if (
              showPhoneAlarm(
                true,
                "toast",
                null,
                2000,
                data.code,
                "预约",
                data.message
              )
            ) {
              this.$router.push({ path: "/dashboard/reserve", query: {} });
            }
            that.waiting = false;
          })
          .finally(() => {
            that.waiting = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
